export const SECTION_TITLE= 'Timesheet';
export const SELECT_PROJECT = 'Please, select a project';
export const SELECT_ENTITY = 'This entity has no projects, please select another entiy';
export const NO_DATA = 'There is no data for the current selection'